


































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { CategoryInterface } from '../../interfaces/Category.interface'
import { ItemAddedInterface } from '../../interfaces/ItemAdded.interface'
import { CartInterface } from '../../interfaces/Cart.interface'
import { CartItemInterface } from '../../interfaces/CartItem.interface'
import { CategoryCustomPropertiesInterface } from '../../interfaces/CategoryCustomProperties.interface'

@Component({
  name: 'ResortOsView',
})
export default class ResortOsView extends Vue {
  private targetEl: Element | null = null
  private sourceEl: HTMLElement | null = null
  private lastItemAddedId: number | null = null
  private lastItemAddedQuantity: number | null = null
  private dialog: boolean = false
  private isEditedProduct: boolean = false
  @Prop({ default: '' }) vsfcategories: string
  @Getter('cart/editCart') editCart

  private backToCategory(): void {
    const isExternalUrlCategory = this.categoryCustomProperties?.isExternalUrlCategory
    const categoryExternalUrl = this.categoryCustomProperties?.categoryExternalUrl
    if (isExternalUrlCategory && categoryExternalUrl) {
      window.location.href = categoryExternalUrl
    } else {
      const currentCategory = this.$route.params.category
      const currentSubcategory = this.$route.params.subcategory
      if (this.category?.ShowPricingCalendar) {
        this.$router.push({
          name: 'product-pricing-calendar',
          params: {
            category: currentCategory,
            subcategory: currentSubcategory,
            product: this.category.PricingCalendarProduct,
          },
        })
      } else {
        this.$store.dispatch('products/resetSelectedProductDefaults')
        this.$store.dispatch('products/clearSelectedProduct')
        this.$router.push({
          name: 'product-category',
          params: { category: currentCategory, subcategory: currentSubcategory },
        })
      }
    }
  }
  private displayToast(): void {
    this.dialog = true
  }
  private hideToast(): void {
    this.isEditedProduct = false
    this.dialog = false
  }
  private goToCart(): void {
    window.location.href = '/cart'
  }

  get cart(): CartInterface {
    return this.$store.getters['cart/cart']
  }
  get category(): CategoryInterface {
    return this.$store.getters['products/category']
  }
  get lastItemAdded(): ItemAddedInterface {
    return this.$store.getters['cart/getLastItemAdded']
  }
  get cartItems(): CartItemInterface[] {
    return this.cart.Items
  }
  get categoriesLoaded(): boolean {
    return !!this.category?.ProductDetails?.length
  }
  get itemToDisplay(): CartItemInterface | undefined {
    return this.cartItems.find((item) => item.ProductId === this.lastItemAddedId)
  }
  get cartItemCount(): number {
    return this.$store.getters['cart/cartItemCount']
  }
  get categoryName(): string | null {
    return this.$store.getters['products/category'] ? this.$store.getters['products/category'].Name : null
  }
  get categoryCustomProperties(): CategoryCustomPropertiesInterface | undefined {
    return this.category?.CustomProperties
  }
  get categoryRoute(): string {
    return `/s/${this.$route.params.category}`
  }
  get vsfCategoryList(): number[] {
    const list = this.vsfcategories.split(',')
    const numberArray = list.map(Number)
    return numberArray
  }

  @Watch('editCart')
  onEditModeChanged(newValue, oldValue) {
    if (oldValue === true && newValue === false) {
      this.isEditedProduct = true
      this.displayToast()
    }
  }

  @Watch('lastItemAdded')
  onCartItemAdded(newValue, oldValue) {
    if (newValue?.ProductId === null) {
      return
    }
    if (newValue?.ProductId !== -1 && oldValue?.ProductId === -1) {
      this.lastItemAddedId = newValue.ProductId
      this.lastItemAddedQuantity = newValue.Quantity
    }
  }

  @Watch('cartItemCount')
  onAddToCard(newValue, oldValue) {
    if (newValue !== oldValue && newValue > oldValue) {
      if (this.lastItemAddedId) {
        this.displayToast()
      }
    }
  }
}
